import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import useUrls from "../../../../hooks/useUrls";

import http from "../../../../services/httpService";
import Util from "../../../../util/util";

export default function AdminRemoteReviewButton({
  finalDocType,
  review,
  action,
  data,
}) {
  const history = useHistory();
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState("");
  const { apiUrl } = useUrls();

  const mutation = useMutation(
    (data) => {
      data.docType = "RemoteReview";
      const url = `${apiUrl}/admin/docs/${data.id}`;
      delete data.id;

      const config = Util.addTokenToHeaders();
      console.log(`sending request to url ${url} with data:`, data);
      return http.put(url, data, config);
    },
    {
      onSuccess: async () => {
        console.log(`review ${finalDocType} update - mutation success`);
        await queryClient.invalidateQueries([
          "admin",
          "remote",
          "reviews",
          finalDocType,
        ]);
        history.push(`/admin/remote/reviews/${finalDocType}`);
      },
      onError: (error) => {
        setErrorMessage(error.response.data.error);
      },
    }
  );

  const color =
    action === "skip" ? "red" : action === "add" ? "green" : "black";
  const buttonStyle =
    action === "update" ? null : { borderColor: color, color };

  return (
    <>
      <button
        onClick={() => mutation.mutate({ id: review.id, action, ...data })}
        className={"btn"}
        style={buttonStyle}
      >
        {action}
      </button>{" "}
      {mutation.isLoading ? (
        `doing ${action} now...`
      ) : errorMessage ? (
        <span className={"alert"}>ERROR: {errorMessage}</span>
      ) : (
        ""
      )}
    </>
  );
}
